"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDatePicker = void 0;
var tslib_1 = require("tslib");
var moment_timezone_1 = (0, tslib_1.__importDefault)(require("moment-timezone"));
var react_1 = require("react");
var react_popper_1 = require("react-popper");
var click_outside_1 = require("../../../hooks/click-outside");
var key_event_1 = require("../../../hooks/key-event");
var helpers_1 = require("./helpers");
function useDatePicker(options) {
    var value = options.value, isDisabled = options.isDisabled, isRequired = options.isRequired, maxDate = options.maxDate, maxYear = options.maxYear, minDate = options.minDate, minYear = options.minYear, onAccept = options.onAccept, format = options.format, timezone = options.timezone, targetRef = options.targetRef, popoverRef = options.popoverRef;
    var _a = (0, react_1.useState)(false), visible = _a[0], setVisible = _a[1];
    (0, click_outside_1.useOnClickOutside)(popoverRef, function () {
        setVisible(false);
    });
    var _b = (0, react_popper_1.usePopper)(targetRef, popoverRef, {
        placement: 'bottom-start',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 4],
                },
            },
        ],
    }), styles = _b.styles, attributes = _b.attributes, update = _b.update;
    (0, react_1.useEffect)(function () {
        if (update) {
            update();
        }
    }, [visible, update]);
    (0, key_event_1.useKeyEvent)('Tab', function () { return setVisible(false); }, []);
    (0, key_event_1.useKeyEvent)('Enter', function () { return setVisible(false); }, []);
    var isValid = (0, helpers_1.isValidDate)(value, {
        maxDate: maxDate,
        maxYear: maxYear,
        minDate: minDate,
        minYear: minYear,
        nullable: isRequired === false,
        format: format,
        timezone: timezone,
    });
    var inputValue = (0, helpers_1.maybeDateToInputValue)(value, format, isDisabled, timezone);
    (0, react_1.useEffect)(function () {
        if (!onAccept)
            return;
        if (value && isValid) {
            var date = moment_timezone_1.default.tz(inputValue, format, timezone).toISOString();
            onAccept(date);
        }
        else {
            onAccept(null);
        }
    }, [isValid, value, onAccept]);
    return {
        visible: visible,
        setVisible: setVisible,
        inputValue: inputValue,
        isValid: isValid,
        isInputInvalid: isValid,
        popperAttributes: attributes.popper,
        popperStyles: styles.popper,
    };
}
exports.useDatePicker = useDatePicker;
//# sourceMappingURL=popover.js.map